export default __webpack_public_path__ + "static/media/fpx.dcc4ce9b.png";